import Vue from 'vue'
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'

// https://vuetifyjs.com/en/styles/transitions#create-your-own
// Add your styles to src/sass/_transitions.scss

const dialogBottomTransition10 = createSimpleTransition('dialog-bottom-transition-10')

Vue.component('dialog-bottom-transition-10', dialogBottomTransition10)
